import ReportingAppointmentList from "./list";


if (document.body.getAttribute("data-current-path") === "reporting/appointment") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ReportingAppointmentList();
    }
}